import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const knowledgeLibraryServices = {
  addNewKnowledgeLibraryItem,
  updateKnowledgeLibraryItem,
  getKnowledgeLibraryData,
  softDeleteRestoreKnowledgeLibraryItem,
  deleteKnowledgeLibraryItem,
  searchKnowledgeLibrary,
};

async function addNewKnowledgeLibraryItem(payload) {
  const response = await fetch(
    `${config.API_URL}addNewKnowledgeLibraryItem`,
    headersWithAuth("POST", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateKnowledgeLibraryItem(payload) {
  const response = await fetch(
    `${config.API_URL}updateKnowledgeLibraryItem`,
    headersWithAuth("PUT", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreKnowledgeLibraryItem(payload) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreKnowledgeLibraryItem`,
    headersWithAuth("PUT", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteKnowledgeLibraryItem(payload) {
  const response = await fetch(
    `${config.API_URL}deleteKnowledgeLibraryItem`,
    headersWithAuth("DELETE", payload, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getKnowledgeLibraryData(status = "active", queryParams = {}) {
  const query = new URLSearchParams();
  Object.entries(queryParams || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const response = await fetch(
    `${config.API_URL}getKnowledgeLibraryData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function searchKnowledgeLibrary(payload) {
  const response = await fetch(
    `${config.API_URL}searchKnowledgeLibrary`,
    headersWithAuth("POST", payload, headers)
  );
  const data = await response.json();
  return data;
}
